"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProviderLogoObjects = exports.getProviderImageUrl = void 0;
var provider_components_1 = require("@kyruus/provider-components");
Object.defineProperty(exports, "getProviderImageUrl", { enumerable: true, get: function () { return provider_components_1.getProviderImageUrl; } });
Object.defineProperty(exports, "getProviderLogoObjects", { enumerable: true, get: function () { return provider_components_1.getProviderLogoObjects; } });
//# sourceMappingURL=images.js.map